import { useCallback, useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  IFetchBoundEmailsParams,
  selectBoundEmails,
  selectBoundEmailsLoading,
  selectBoundEmailsState,
  useFetchBoundEmailsQuery,
  useLazyFetchBoundEmailsQuery,
} from '../actions/email/fetchBoundEmails';

export interface IUseBoundEmailsProps
  extends IFetchBoundEmailsParams,
    IUseQueryProps {}

export const useBoundEmails = ({
  filters,
  skipFetching,
}: IUseBoundEmailsProps = {}) => {
  const params = useMemo(
    (): IFetchBoundEmailsParams => ({ filters }),
    [filters],
  );

  useFetchBoundEmailsQuery(getQueryParams({ params, skipFetching }));

  const [fetchLazy] = useLazyFetchBoundEmailsQuery();

  const handleFetchBoundEmails = useCallback(
    () => fetchLazy(params),
    [fetchLazy, params],
  );

  const emails = useAppSelector(state => selectBoundEmails(state, params));
  const loading = useAppSelector(state =>
    selectBoundEmailsLoading(state, params),
  );
  const state = useAppSelector(storeState =>
    selectBoundEmailsState(storeState, params),
  );

  const { isUninitialized } = state;

  return {
    emails,
    handleFetchBoundEmails,
    loading,
    params,
    state,
    isUninitialized,
  };
};
